import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {SnamPlantKey, UICommand} from "shared/constants";
import { set } from "lodash";

export interface IPlantsState{
    plantId:string|undefined;
}
const plantInitialState:IPlantsState = {
    plantId:undefined
}
//Used to dispatch commands (as i.e. reload data)
export const PlantSlice = createSlice({
    name:"plants",
    initialState:plantInitialState,
    reducers:{
        setPlant(state:IPlantsState, action:PayloadAction<IPlantsState>){
            state.plantId =  action.payload.plantId;
        }
    }
});
export const {setPlant} = PlantSlice.actions;
export default PlantSlice.reducer;